export function h(TagOrElement, props = {}, ...childNodes) {
    const element = typeof TagOrElement === 'string'
        ? document.createElement(TagOrElement)
        : new TagOrElement();
    if (props === null) {
        props = {};
    }
    const setProperty = (key, value) => {
        if (key == null) {
            return;
        }
        if (typeof value === 'function') {
            element[key] = value;
        }
        else {
            element.setAttribute(key, value == null ? '' : value.toString());
        }
    };
    for (const key of Object.keys(props)) {
        setProperty(key, props[key]);
    }
    const appendChild = (node) => {
        if (node instanceof Node) {
            element.appendChild(node);
        }
        else if (node instanceof NodeList || node instanceof HTMLCollection) {
            for (const n of Array.prototype.slice.call(node)) {
                element.appendChild(n);
            }
        }
        else {
            element.appendChild(document.createTextNode(String(node)));
        }
    };
    for (const node of childNodes.filter(x => x != null)) {
        if (Array.isArray(node)) {
            for (const n of node) {
                appendChild(n);
            }
        }
        else {
            appendChild(node);
        }
    }
    return element;
}
//# sourceMappingURL=index.js.map